import AdminLayout from 'components/Layouts/AdminLayout';
import PersistLogin from 'components/PersistLogin';
import RequireAuth from 'components/RequireAuth';
import Dasboard from 'pages/admin/Dasboard';
import User from 'pages/admin/data/User';
import Businesses from 'pages/admin/data/Businesses';
import Site from 'pages/admin/setting/Site';
import Login from 'pages/Login';
import { Route, Routes } from 'react-router-dom';
import Layout from './components/Layouts/Layout';
import Index from './pages';
import Blog from 'pages/Blog';
import BlogShow from 'pages/BlogShow';
import Blogs from 'pages/admin/data/Blogs';
import NotFound from 'pages/NotFound';
import Events from 'pages/Events';
import EventsAdmin from 'pages/admin/data/Events';
import EventsShow from 'pages/EventsShow';
import JobPostAdmin from 'pages/admin/data/JobPost';
import JobPost from 'pages/JobPost';
import JobPostShow from 'pages/JobPostShow';
import AdminData from 'pages/admin/setting/AdminData';
import Payments from 'pages/admin/data/Payments';

function App() {
  return (
    <Routes>
      <Route element={<Layout/>}>
        <Route path='/' element={<Index/>}></Route>
        <Route path='/blogs' element={<Blog/>}></Route>
        <Route path='/blogs/:slug' element={<BlogShow/>}></Route>
        <Route path='/events' element={<Events/>}></Route>
        <Route path='/events/:slug' element={<EventsShow/>}></Route>
        <Route path='/job-posts' element={<JobPost/>}></Route>
        <Route path='/job-posts/:slug' element={<JobPostShow/>}></Route>
      </Route>
      <Route path='/login' element={<Login/>}></Route>
      <Route element={<PersistLogin/>}>
        <Route element={<RequireAuth/>}>
          <Route path='/admin' element={<AdminLayout/>}>
            <Route path='data'>
              <Route element={<RequireAuth adminOnly/>}>
                <Route path='user' element={<User/>}></Route>
                <Route path='events' element={<EventsAdmin/>}></Route>
                <Route path='job-posts' element={<JobPostAdmin/>}></Route>
              </Route>
              <Route path='businesses' element={<Businesses/>}></Route>
              <Route path='blogs' element={<Blogs/>}></Route>
              <Route path='payments' element={<Payments/>}></Route>
            </Route>
            <Route path='setting'>
              <Route element={<RequireAuth adminOnly/>}>
                <Route path='site' element={<Site/>}></Route>
              </Route>
              <Route element={<RequireAuth adminOnly/>}>
                <Route path='admin' element={<AdminData/>}></Route>
              </Route>
            </Route>
            <Route index element={<Dasboard/>}></Route>
          </Route>
        </Route>
      </Route>
      <Route element={<Layout/>}>
        <Route path='/unauthorized' element={<NotFound code={401} message="Unauthorized"/>}/>
        <Route path='*' element={<NotFound/>}/>
      </Route>
    </Routes>
  );
}

export default App;
